
import { defineComponent } from 'vue';

import SocialMediaIconBox from '../../../components/Frontend/SocialMediaIconBox.vue';
import Footer from '../../../components/Frontend/Footer.vue';
import HeaderImageBoxGenerel from '../../../components/Frontend/HeaderImageBoxGenerel.vue';



import { mdiChevronUp } from '@mdi/js';

export default defineComponent({
  meta: {
    de: {
      title: 'Talentepool | Styria Media Group',
      keywords: ['talentepool','talent','job','karriere','job','styria media group'],
      description: 'Fehlt der passende ausgeschriebene Job? Dann auf in unseren Talentepool!',
      image: require('@/assets/img/og/karriere.png'),
      
    },
    en: {
      title: 'Talent pool | Styria Media Group',
      keywords: ['talent pool','talent','job','career','styria media group'],
      description: 'Are you missing the right job? Then enter our talent pool!',
      image: require('@/assets/img/og/karriere.png'),
    },
  },
  components: {
    SocialMediaIconBox,
    //HeaderImageBoxGenerel,
    Footer,

    
  },
  setup() {
    return {
      mdiChevronUp,
    };
  },
});
